export default __webpack_public_path__ + "static/media/slide1.157411c7.jpg";